export const metrics = {
  visits: { key: 'mt:visits' },
  pageviews: { key: 'mt:pageviews' },
  dailyVisitors: { key: 'mt:dailyVisitors' },
  avgPageDepth: { key: 'mt:pageviews', dividedBy: 'mt:visits', noSummary: true },
  avgVisitDuration: { key: 'mt:visitDuration', dividedBy: 'mt:visits' },
  newVisitors: { key: 'mt:newVisits', dividedBy: 'mt:visits', usePercentage: true },
  bounceRate: { key: 'mt:bounces', dividedBy: 'mt:visits', usePercentage: true }
}

export const fakeSiteBrand = [1, 2, 3, 4, 5].map(i => ({ value: i, label: `Brand ${i}` }))

export const fakeData = {
  thisPeriodSummary:
    {
      'mt:visits': '62167',
      'mt:pageviews': '93546',
      'mt:newVisits': '35115',
      'mt:bounces': '29562',
      'mt:entrances': '62167',
      'mt:uniquePageviews': '78407',
      'mt:visitDuration': '7845460',
      'mt:exits': '62167',
      'mt:pageLoadTime': '117057061',
      'mt:dailyVisitors': '54590'
    },
  lastPeriodSummary:
    {
      'mt:visits': '72918',
      'mt:pageviews': '104877',
      'mt:newVisits': '45352',
      'mt:bounces': '39283',
      'mt:entrances': '72918',
      'mt:uniquePageviews': '89234',
      'mt:visitDuration': '8344687',
      'mt:exits': '72918',
      'mt:pageLoadTime': '139623902',
      'mt:dailyVisitors': '64681'
    },
  thisPeriodByDate: [
    {
      'dm:date': '2024-11-14',
      'mt:visits': '2350',
      'mt:pageviews': '3948',
      'mt:newVisits': '1310',
      'mt:bounces': '1057',
      'mt:entrances': '2350',
      'mt:uniquePageviews': '3301',
      'mt:visitDuration': '339578',
      'mt:exits': '2350',
      'mt:pageLoadTime': '6706496',
      'mt:dailyVisitors': '2045'
    },
    {
      'dm:date': '2024-11-15',
      'mt:visits': '2167',
      'mt:pageviews': '3540',
      'mt:newVisits': '1163',
      'mt:bounces': '951',
      'mt:entrances': '2167',
      'mt:uniquePageviews': '2958',
      'mt:visitDuration': '317680',
      'mt:exits': '2167',
      'mt:pageLoadTime': '5111086',
      'mt:dailyVisitors': '1866'
    },
    {
      'dm:date': '2024-11-16',
      'mt:visits': '999',
      'mt:pageviews': '1505',
      'mt:newVisits': '655',
      'mt:bounces': '566',
      'mt:entrances': '999',
      'mt:uniquePageviews': '1250',
      'mt:visitDuration': '82669',
      'mt:exits': '999',
      'mt:pageLoadTime': '2116405',
      'mt:dailyVisitors': '908'
    },
    {
      'dm:date': '2024-11-17',
      'mt:visits': '910',
      'mt:pageviews': '1462',
      'mt:newVisits': '613',
      'mt:bounces': '533',
      'mt:entrances': '910',
      'mt:uniquePageviews': '1173',
      'mt:visitDuration': '84184',
      'mt:exits': '910',
      'mt:pageLoadTime': '1655002',
      'mt:dailyVisitors': '835'
    },
    {
      'dm:date': '2024-11-18',
      'mt:visits': '2235',
      'mt:pageviews': '3544',
      'mt:newVisits': '1230',
      'mt:bounces': '965',
      'mt:entrances': '2235',
      'mt:uniquePageviews': '2911',
      'mt:visitDuration': '312998',
      'mt:exits': '2235',
      'mt:pageLoadTime': '4789763',
      'mt:dailyVisitors': '1962'
    },
    {
      'dm:date': '2024-11-19',
      'mt:visits': '2100',
      'mt:pageviews': '3376',
      'mt:newVisits': '1072',
      'mt:bounces': '883',
      'mt:entrances': '2100',
      'mt:uniquePageviews': '2821',
      'mt:visitDuration': '281101',
      'mt:exits': '2100',
      'mt:pageLoadTime': '4111755',
      'mt:dailyVisitors': '1796'
    },
    {
      'dm:date': '2024-11-20',
      'mt:visits': '1950',
      'mt:pageviews': '2858',
      'mt:newVisits': '1046',
      'mt:bounces': '824',
      'mt:entrances': '1950',
      'mt:uniquePageviews': '2462',
      'mt:visitDuration': '277127',
      'mt:exits': '1950',
      'mt:pageLoadTime': '3761710',
      'mt:dailyVisitors': '1698'
    }
  ],
  lastPeriodByDate: [
    {
      'dm:date': '2024-11-07',
      'mt:visits': '2294',
      'mt:pageviews': '3659',
      'mt:newVisits': '1265',
      'mt:bounces': '1025',
      'mt:entrances': '2294',
      'mt:uniquePageviews': '3041',
      'mt:visitDuration': '318318',
      'mt:exits': '2294',
      'mt:pageLoadTime': '4651178',
      'mt:dailyVisitors': '2012'
    },
    {
      'dm:date': '2024-11-08',
      'mt:visits': '2185',
      'mt:pageviews': '3338',
      'mt:newVisits': '1193',
      'mt:bounces': '990',
      'mt:entrances': '2185',
      'mt:uniquePageviews': '2827',
      'mt:visitDuration': '302478',
      'mt:exits': '2185',
      'mt:pageLoadTime': '4510049',
      'mt:dailyVisitors': '1927'
    },
    {
      'dm:date': '2024-11-09',
      'mt:visits': '1131',
      'mt:pageviews': '1785',
      'mt:newVisits': '776',
      'mt:bounces': '673',
      'mt:entrances': '1131',
      'mt:uniquePageviews': '1477',
      'mt:visitDuration': '96512',
      'mt:exits': '1131',
      'mt:pageLoadTime': '2011448',
      'mt:dailyVisitors': '1031'
    },
    {
      'dm:date': '2024-11-10',
      'mt:visits': '1125',
      'mt:pageviews': '1733',
      'mt:newVisits': '772',
      'mt:bounces': '668',
      'mt:entrances': '1125',
      'mt:uniquePageviews': '1388',
      'mt:visitDuration': '112548',
      'mt:exits': '1125',
      'mt:pageLoadTime': '2447247',
      'mt:dailyVisitors': '1018'
    },
    {
      'dm:date': '2024-11-11',
      'mt:visits': '2491',
      'mt:pageviews': '3893',
      'mt:newVisits': '1350',
      'mt:bounces': '1062',
      'mt:entrances': '2491',
      'mt:uniquePageviews': '3258',
      'mt:visitDuration': '320844',
      'mt:exits': '2491',
      'mt:pageLoadTime': '4865746',
      'mt:dailyVisitors': '2135'
    },
    {
      'dm:date': '2024-11-12',
      'mt:visits': '2177',
      'mt:pageviews': '3726',
      'mt:newVisits': '1165',
      'mt:bounces': '942',
      'mt:entrances': '2177',
      'mt:uniquePageviews': '3008',
      'mt:visitDuration': '329190',
      'mt:exits': '2177',
      'mt:pageLoadTime': '3805298',
      'mt:dailyVisitors': '1903'
    },
    {
      'dm:date': '2024-11-13',
      'mt:visits': '2162',
      'mt:pageviews': '3641',
      'mt:newVisits': '1154',
      'mt:bounces': '921',
      'mt:entrances': '2162',
      'mt:uniquePageviews': '2965',
      'mt:visitDuration': '322110',
      'mt:exits': '2162',
      'mt:pageLoadTime': '4006217',
      'mt:dailyVisitors': '1881'
    }
  ]
}
